import { render, staticRenderFns } from "./PatternVue.vue?vue&type=template&id=068b00d6"
import script from "./PatternVue.vue?vue&type=script&lang=js"
export * from "./PatternVue.vue?vue&type=script&lang=js"
import style0 from "./PatternVue.vue?vue&type=style&index=0&id=068b00d6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports